function Skills() {
    return(
        <section className="about-content">
        <h3>Skills & Technologies</h3>
        <section className="technologies">
            <div>
                <p>Figma</p>
                <p>Design Systems</p>
                <p>Responsive Design</p>
                <p>WCAG 2.1/2.2</p>
            </div>
            <div>
                <p>UX Research & Analysis</p>
                <p>User Journey Mapping</p>
                <p>Usability Heuristics</p>
                <p>Agile Frameworks</p>
            </div>
            <div>
                <p>Design Feasibility</p>
                <p>AI-Assisted Workflows</p>
                <p>Adobe Creative Cloud</p>
                <p>HTML/CSS/JS Literacy</p>
            </div>
        </section>
        <section className="technologies-mobile">
            <div>
                <p>Figma</p>
                <p>Design Systems</p>
                <p>Responsive Design</p>
                <p>WCAG 2.1/2.2</p>
                <p>UX Research & Analysis</p>
                <p>User Journey Mapping</p>
            </div>
            <div>
                <p>Usability Heuristics</p>
                <p>Agile Frameworks</p>
                <p>Design Feasibility</p>
                <p>AI-Assisted Workflows</p>
                <p>Adobe Creative Cloud</p>
                <p>HTML/CSS/JS Literacy</p>
            </div>
        </section>
    </section>
    );
};

export default Skills;